import React from "react";
import DesktopBanner from "../../assets/images/bannner 2.png";
import MobileBanner from "../../assets/images/mobileView2.png";

export default function FrontPageBanner() {
  return (
    <section className="front-banner">
      <img
        src={DesktopBanner}
        alt="Desktop Banner"
        className="banner-img desktop-banner"
      />

      {/* Mobile Banner */}
      <img
        src={MobileBanner}
        alt="Mobile Banner"
        className="banner-img mobile-banner"
      /> 

      <style jsx>{`
        .front-banner {
          position: relative;
          overflow: hidden;
          width: 100%;
          height: 60vh;
          margin-top: 120px; 
        }

        .banner-img {
          width: 100%;
          height: 100%;
          object-fit: fill;
          object-position: center;
          display: block;
        }

       /* Desktop Image Show */
        .desktop-banner {
          display: block;
        }
        /* Mobile Image Hide */
        .mobile-banner {
          display: none;
        }


        /* Tablet */
        @media (max-width: 992px) {
          .front-banner {
            height: 70vh;
            margin-top: 110px; /* Mobile top-header (two rows ~80px) + bottom-header (~110px) */
          }
          .banner-img {
            object-fit: fill;
          }
        }

        /* Mobile */
        @media (max-width: 768px) {
           .desktop-banner {
            display: none;
          }

          .mobile-banner {
            display: block;
          }
          
          .front-banner {
            height: 50vh;
            margin-top: 160px;
          }

          .banner-img {
            object-fit: fill;
          }
        }

        /* Small Mobile */
        @media (max-width: 480px) {
          .front-banner {
            height: 70vh;
            margin-top: 99px;
          }
        }
      `}</style>
    </section>
  );
}